import { useNavigate } from "react-router-dom"
import useListBu from "./useListBu"
import { useEffect, useState } from "react"
import PaginationComponent from "../../../../components/pagination/PaginationComponent"
import { BsPencilSquare, BsFillTrashFill } from "react-icons/bs"
import { SearchOutlined } from '@ant-design/icons'
import DeleteModal from "../../../../components/modal/DeleteModal"
import { Input, Select } from "antd"
import Loading from "../../../../components/loading/Loading"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const ListBusinessUnit = ({ hideCreateButton = false }) => {
    const navigate = useNavigate()
    const {
        payload, 
        getListBu,
        handleFileChange,
        postBulkBu,
        page, 
        changePage,
        totalPage,
        deleteBusinessUnit,
        setFilterNameUser,
        limit, 
        filterName,
        setFilterLimit,
        loadingPagestate
    } = useListBu()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState()
    const [userName, setName] = useState()
    const [limitOptions, setLimitOptions] = useState([
        {'label': 10, 'value':10},
        {'label': 25, 'value':25},
        {'label': 50, 'value':50},
        {'label': 100, 'value':100},
    ])
    useEffect(() => {
        getListBu(page)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit, filterName])
    
    return(
        <div>
            <Loading state={loadingPagestate}/>
            {!hideCreateButton && (
                <div className="d-flex">
                    <ActionButtonGradient
                        onClick={() => navigate('/bu-management/bu-form')}
                        variant="success"
                        children={"Create Business Unit"}
                    />
                </div>
            )}
            <div>
                <h6 style={{ fontWeight: 600, fontSize: '14px', marginBottom: '12px' }}>Bulk Insert</h6>
                <form onSubmit={() => {
                    postBulkBu()
                }}>
                    <input 
                        type="file" 
                        className="form-control" 
                        accept=" application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileChange} 
                    />
                    <div align="right" className="mt-2">
                        <ActionButtonGradient
                            type="submit"
                            variant="primary"
                            children={"Upload File"}
                        />
                    </div>
                </form>
            </div>
            <div className="table-responsive mt-3">
                <Input 
                    className="mb-2" 
                    placeholder="Search by business unit name" 
                    allowClear 
                    onChange={setFilterNameUser}
                    prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                />
                <table className="table align-items-center">
                    <thead>
                        <tr>
                            <th scope="col">Business Unit ID</th>
                            <th scope="col">Pillar</th>
                            <th scope="col">Business Unit Group</th>
                            <th scope="col">Business Unit Name</th>
                            <th scope="col">Status</th>
                            <th scope="col" style={{width: '5%'}}></th>
                            <th scope="col" style={{width: '5%'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            payload && payload.map((data) => (
                                <tr key={data.ID}>
                                    <td>{data.ID}</td>
                                    <td>{data.Pillar}</td>
                                    <td>{data.GroupBusinessUnit.GroupName}</td>
                                    <td>{data.Name}</td>
                                    <td>{data.Status?"Active":"Inactive"}</td>
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            title="Edit Business Unit"
                                            onClick={() => navigate(`/bu-management/bu-form/${data.ID}`)}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #02B4CC',
                                                backgroundColor: 'transparent',
                                                color: '#02B4CC',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#02B4CC';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#02B4CC';
                                            }}
                                        >
                                            <BsPencilSquare/>
                                            Edit
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button 
                                            className="btn" 
                                            title="Delete Business Unit"
                                            onClick={() => {
                                                handleShow()        
                                                setDeleteID(data.ID)
                                                setName(data.Name)
                                            }}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #dc3545',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#dc3545';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#dc3545';
                                            }}
                                        >
                                            <BsFillTrashFill/>
                                            Delete
                                        </button>
                                    </td>
                                </tr>      
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div align="right">
                <Select
                    style={{marginLeft: "0.5rem"}}
                    defaultValue={10}
                    options={limitOptions}
                    onChange={(e) => setFilterLimit(e)}
                />
            </div>
            <div className="table-responsive">
                <PaginationComponent
                    current={page}
                    totalPages={totalPage}
                    navigate={changePage}
                />
            </div>
            
            <DeleteModal show={show} handleClose={handleClose} handleOk={async () => {
                await deleteBusinessUnit(deleteID)
                handleClose()
            }} title={userName}/>
        </div>
    )
}

export default ListBusinessUnit